import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import ExecutiveS from './ExecutiveS';
import TimelineP from './TimelineP';
import Training from './Training';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#TP') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
    } else if (key === '#ES') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
    } else if (key === '#TNP') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#TP' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Timeline</Text></Content>}/>
          <Link href='#ES' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2vh'}}>Executive Summary</Text></Content>}/>
          <Link href='#TNP' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '3vh'}}>Training</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> O&nbsp;<br/> V&nbsp;<br/> E&nbsp;<br/> R&nbsp;<br/> V&nbsp;<br/> I&nbsp;<br/> E&nbsp;<br/> W&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='TP'>
              <TimelineP/>
            </div>
            <div id='ES'>
              <ExecutiveS/>
            </div>
            <div id='TNP'>
              <Training/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipLogic;
